import type { Rating, RatingPreview } from "@glosor/shared";

interface Props {
  onRate: (rating: Rating) => void;
  disabled?: boolean;
  defaultRating?: Rating;
  preview?: RatingPreview;
}

const BUTTONS: Array<{ rating: Rating; label: string; className: string; previewKey: keyof RatingPreview }> = [
  { rating: 1, label: "Again", className: "bg-rose-600 hover:bg-rose-500", previewKey: "again" },
  { rating: 2, label: "Hard", className: "bg-amber-600 hover:bg-amber-500", previewKey: "hard" },
  { rating: 3, label: "Good", className: "bg-emerald-600 hover:bg-emerald-500", previewKey: "good" },
  { rating: 4, label: "Easy", className: "bg-sky-600 hover:bg-sky-500", previewKey: "easy" },
];

export default function RatingButtons({ onRate, disabled, defaultRating = 3, preview }: Props) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {BUTTONS.map((b) => (
        <button
          key={b.rating}
          autoFocus={b.rating === defaultRating}
          onClick={() => onRate(b.rating)}
          disabled={disabled}
          className={[
            "btn relative text-white text-sm sm:text-base font-semibold py-3 sm:py-4",
            b.className,
            "disabled:opacity-50",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-white/80 dark:focus-visible:ring-offset-slate-900",
          ].join(" ")}
        >
          <span className="absolute left-1.5 top-1 text-[10px] font-bold opacity-60">
            {b.rating}
          </span>
          <span className="flex flex-col items-center leading-tight">
            <span>{b.label}</span>
            {preview && (
              <span className="text-[10px] font-normal opacity-80 mt-0.5">
                {preview[b.previewKey]}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
}
